/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorTrendingMenu from 'base/components/labrador/TrendingMenu';

export const DynamicLabradorTrendingMenu: typeof LabradorTrendingMenu = (props) => {
    return <ErrorBoundary><LabradorTrendingMenu {...props} /></ErrorBoundary>;
}
export type DynamicLabradorTrendingMenuProps = PropsFromComponent<typeof LabradorTrendingMenu>;
